// API key + provider preference. Keys live ONLY in the user's browser.
// Default: in-memory (cleared on tab close). Opt-in: localStorage (persist).

const KEY_STORAGE = 'promo-studio:ai-key';
const PROVIDER_STORAGE = 'promo-studio:ai-provider';
const REMEMBER_STORAGE = 'promo-studio:ai-remember';

export type Provider = 'anthropic' | 'openai';

export interface AIConfig {
  provider: Provider;
  apiKey: string;
  remember: boolean;
}

let memoryKey = '';

export function loadConfig(): AIConfig {
  const provider = (localStorage.getItem(PROVIDER_STORAGE) as Provider) || 'anthropic';
  const remember = localStorage.getItem(REMEMBER_STORAGE) === '1';
  const apiKey = remember ? localStorage.getItem(KEY_STORAGE) || '' : memoryKey;
  return { provider, apiKey, remember };
}

export function saveConfig(cfg: AIConfig): void {
  localStorage.setItem(PROVIDER_STORAGE, cfg.provider);
  localStorage.setItem(REMEMBER_STORAGE, cfg.remember ? '1' : '0');
  if (cfg.remember) {
    if (cfg.apiKey) localStorage.setItem(KEY_STORAGE, cfg.apiKey);
    else localStorage.removeItem(KEY_STORAGE);
    memoryKey = cfg.apiKey;
  } else {
    localStorage.removeItem(KEY_STORAGE);
    memoryKey = cfg.apiKey;
  }
}

export function clearAllAI(): void {
  localStorage.removeItem(KEY_STORAGE);
  localStorage.removeItem(REMEMBER_STORAGE);
  localStorage.removeItem(PROVIDER_STORAGE);
  memoryKey = '';
}
